<template>
  <div>
  <mdb-modal
    centered
    elegant
    scrollable
    size="xl"
    :show="mostrarModal"
  >
    <mdb-modal-header :close="false">
      <mdb-modal-title>
        Productos comprados
      </mdb-modal-title>
      <a
        class="close"
        @click="$emit('cerrar', false);"
      >×</a>
    </mdb-modal-header>
    <mdb-modal-body class="pt-0">
      <header class="font-weight-bold mb-2">
        Productos
        {{ cliente ? cliente.nom_cli : '' }}
      </header>
      <table class="border">
        <thead>
          <th>Producto</th>
          <th v-for="(mes, index) in meses" :key="index" @click="$emit('seleccionarMes', mapaMeses[mes])">
            {{ mes }}
          </th>
        </thead>
        <tbody>
          <tr v-for="(p, index) in productos" :key="index">
            <td data-columna="Producto">
              <p class="mb-1">
                {{p.prod}} <br>
                <small class="small-block">{{ p.cod_pre }}</small>
              </p>
            </td>
            <td v-for="(mes, i) in meses" :key="i" :data-columna="mes" @click="$emit('seleccionarMes', mapaMeses[mes])">
              {{ formatCelda(p, mapaMeses[mes]) }}
            </td>
          </tr>
          <tr v-if="!productos.length">
            <td colspan="13" class="text-center">
              <font-awesome-icon icon="clipboard-list" size="5x" class="icono" />
              <p class="texto">No hay productos para mostrar..</p>
            </td>
          </tr>
        </tbody>
      </table>
   </mdb-modal-body>
  </mdb-modal>
  <mdb-modal
    centered
    elegant
    scrollable
    size="lg"
    :show="mostrarMes"
  >
    <mdb-modal-header :close="false">
      <mdb-modal-title>
        Mes de {{ nombreMes }}
      </mdb-modal-title>
      <a
        class="close"
        @click="mostrarMes = false;"
      >×</a>
    </mdb-modal-header>
    <mdb-modal-body class="pt-0">
      <table class="border">
        <thead>
          <th>Producto</th>
          <th>Cantidad</th>
          <th>Monto $</th>
        </thead>
        <tbody>
          <tr v-for="(p, index) in productosDelMes" :key="index">
            <td data-columna="Producto">
              <p class="mb-1">
                {{p.prod}} <br>
                <small class="small-block">{{ p.cod_pre }}</small>
              </p>
            </td>
            <td data-columna="Cantidad">
              {{ numeroAFixed(p.cantidad) }} kg
            </td>
            <td data-columna="Monto">
              $ {{ numeroAFixed(p.monto) }}
            </td>
          </tr>
          <tr v-if="!productosDelMes.length">
            <td colspan="13" class="text-center">
              <font-awesome-icon icon="clipboard-list" size="5x" class="icono" />
              <p class="texto">No hay productos en el mes seleccionado</p>
            </td>
          </tr>
        </tbody>
      </table>
   </mdb-modal-body>
  </mdb-modal>
  </div>

</template>

<script>
import {mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody} from 'mdbvue';
import {convertirNumeroAFixed} from '@/funciones/funciones.js';
export default {
  name: 'ModalProductos',
  components: {
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
  },
  props: {
    mostrarModal: {
      type: Boolean,
      default: false,
    },
    cliente: {
      type: Object,
      default: null,
    },
    productosPorMes: {
      type: Array,
      default: () => [],
    },
    productosDelMes: {
      type: Array,
      default: () => [],
    },
    ano: {
      type: String,
      default: '',
    },
    nombreMes: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      meses: [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
      ],
      mapaMeses: {
        Enero: '1',
        Febrero: '2',
        Marzo: '3',
        Abril: '4',
        Mayo: '5',
        Junio: '6',
        Julio: '7',
        Agosto: '8',
        Septiembre: '9',
        Octubre: '10',
        Noviembre: '11',
        Diciembre: '12',
      },
      mesSeleccionado: '',
      mostrarMes: false,
    };
  },
  computed: {
    productos() {
      if (!this.productosPorMes.length) return [];
      const mapa = {};
      const crearMeses = () => ({
        eneC: 0,
        eneM: 0,
        febC: 0,
        febM: 0,
        marC: 0,
        marM: 0,
        abrC: 0,
        abrM: 0,
        mayC: 0,
        mayM: 0,
        junC: 0,
        junM: 0,
        julC: 0,
        julM: 0,
        agoC: 0,
        agoM: 0,
        sepC: 0,
        sepM: 0,
        octC: 0,
        octM: 0,
        novC: 0,
        novM: 0,
        dicC: 0,
        dicM: 0,
      });
      this.productosPorMes.forEach((item) => {
        const key = item.id_pre;
        if (!mapa[key]) {
          mapa[key] = {
            id_pre: item.id_pre,
            prod: item.prod,
            cod_pre: item.cod_pre,
            ...crearMeses(),
          };
        }
        const mesNum = Number(item.mes);
        const cantidad = Number(item.cantidad) || 0;
        const monto = Number(item.monto) || 0;
        const sufC = 'C';
        const sufM = 'M';
        const claves = {
          1: ['ene', 'ene'],
          2: ['feb', 'feb'],
          3: ['mar', 'mar'],
          4: ['abr', 'abr'],
          5: ['may', 'may'],
          6: ['jun', 'jun'],
          7: ['jul', 'jul'],
          8: ['ago', 'ago'],
          9: ['sep', 'sep'],
          10: ['oct', 'oct'],
          11: ['nov', 'nov'],
          12: ['dic', 'dic'],
        };
        const clave = claves[mesNum];
        if (clave) {
          mapa[key][clave[0] + sufC] += cantidad;
          mapa[key][clave[1] + sufM] += monto;
        }
      });
      return Object.values(mapa);
    },
  },
  watch: {
    mostrarModal(val) {
      if (val && this.productosDelMes.length) {
        this.mostrarMes = true;
      }
    },
    productosDelMes(nuevos) {
      if (nuevos.length) {
        this.mostrarMes = true;
      }
    },
  },
  methods: {
    numeroAFixed(num) {
      return convertirNumeroAFixed(num);
    },
    formatCelda(producto, mesNum) {
      const clave = this.obtenerClaveMes(Number(mesNum));
      const cantidad = producto[clave + 'C'];
      const monto = producto[clave + 'M'];
      if (!cantidad) return '-';
      return `${cantidad} kg / $${this.numeroAFixed(monto)}`;
    },
    obtenerClaveMes(num) {
      const mapa = {
        1: 'ene',
        2: 'feb',
        3: 'mar',
        4: 'abr',
        5: 'may',
        6: 'jun',
        7: 'jul',
        8: 'ago',
        9: 'sep',
        10: 'oct',
        11: 'nov',
        12: 'dic',
      };
      return mapa[num] || '';
    },
  },
};
</script>

<style lang='scss' scoped>

table {
  border-collapse: collapse;
  width: 100%;
}

thead {
  position: sticky;
  top: 0;
  z-index: 10;
  border-bottom: 1px #dddddd solid;
  background-color: #fafafa;
}

th {
  font-weight: 600;
  text-align: left;
  padding: .6rem .4rem .6rem .4rem;
  white-space: nowrap;
  font-size: .7rem;
  text-transform: uppercase;
}

th:last-child {
  border-right: none;
}

td {
  padding: .3rem;
  padding-bottom: 0;
  border-bottom: 1px solid #eee;
  transition: background-color 0.2s;
  font-size: .8rem;
}

tr:hover td {
  background-color: #f9f9f9;
}

tr:nth-child(even):hover td {
  background-color: #f1f3f4;
}

@media (max-width: 576px) {
  table {
    width: 100%;
  }

  thead {
    display: none;
  }

  tr {
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid black;
    width: 90%
  }

  td {
    display: flex;
    flex-wrap: nowrap;
    padding-top: .5rem !important;
    padding-bottom: 0rem !important;
    height: auto !important;
    border: none;
    width: 90% !important;
    min-width: 0;
  }

  td::before {
    content: attr(data-columna) "                          " attr(second-data-columna);
    white-space: pre-wrap;
    font-weight: 500;
    margin-right: .25rem;
    min-width: 105px;
    width: 105px !important;
    flex-shrink: 0;
  }

  td>div {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  td>div>p,
  td>div>span {
    word-break: break-word;
    overflow-wrap: break-word;
    min-width: 0;
  }
}
</style>
